import { withStyles, WithStyles } from "@material-ui/core";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { NavLink } from "react-router-dom";

import { styles } from "./UserStyles";

import TouchAppIcon from "@material-ui/icons/TouchApp";
import userAvatarNew from "../../../../assets/images/Avatar account.svg";
import userNew from "../../../../assets/images/vediAvatar.png";

interface OwnProps {
  handleDrawerToggle: () => void;
}

type PublicProps = OwnProps;
const mapStateToProps = (state: any) => ({
  user: state.usuario.user,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PublicProps & PropsFromRedux & WithStyles<typeof styles>;

const User: React.FC<Props> = (props) => {
  const { classes, user, handleDrawerToggle } = props;
  return (
    <NavLink
      to="/mi-cuenta"
      className={({ isActive }) =>
        isActive
          ? `${classes.container} ${classes.containerSelected}`
          : classes.container
      }
      onClick={handleDrawerToggle}
    >
      <img
        className={classes.image}
        style={!user || !userNew ? { display: "none" } : undefined}
        src={user.urlUserPhoto || userAvatarNew}
        alt="Imagen de usuario"
      />
      <div className={classes.data}>
        <div>
          <b>
            {user.apellido}, <br />
            {user.nombre}
          </b>
        </div>
        <div>DNI {user.dni}</div>
        <span>
          {" "}
          <TouchAppIcon style={{ color: "#004C83" }} />
        </span>
      </div>
    </NavLink>
  );
};

export default connector(
  withStyles(styles)(User)
) as React.ComponentType<PublicProps>;
